angular.
module("dx.webapp.masterTools.studentMerge").
controller("DxMergeConflictsRouteController", function MergeConflictsRouteController(
	$http,
	$scope,
	$interval,

	dxDialog
) {
	"use strict";

	var self = this;
	self.conflicts = [];
	self.selectedCase = "";
	self.currentConflict = 0;
	self.examId = 0;
	self.examStatus = 0;
	self.examEndDate = null;
	self.primaryStudentId = "";
	self.questions = null;
	self.primaryAnswers = null;
	self.sourceAnswers = null;
	self.resolvedId = 0;
	self.hideResolved = true;
	self.lastUpdatedTime = null;

	var API_URL = "/api/v1/mastertools/studentmerge/conflicts";

	self.updateConflicts = function updateConflicts() {
		$http.get(API_URL + "?hideResolved=" + self.hideResolved).then(function onSuccess(response) {
			self.conflicts = response.data;
			self.lastUpdatedTime = new Date();
		});
	};

	$scope.$on("$destroy", function destroy() {
		$interval.cancel(self.updateConflictsInterval);
	});

	$scope.$watch("vm.hideResolved", function updateNow(newValue, oldValue) {
		if (newValue === oldValue) {
			return;
		}

		triggerUpdate();
	});

	self.caseSelected = function caseSelected() {
		if (!self.selectedCase) {
			return;
		}

		$http.get(API_URL + "/" + self.selectedCase).then(function onSuccess(response) {
			self.currentConflict = 0;
			self.examId = response.data.examId;
			self.examStatus = response.data.examStatus;
			self.examEndDate = response.data.examEndDate;
			self.questions = response.data.questions;
			self.primaryStudentId = response.data.primaryStudentId;
			self.primaryAnswers = response.data.primaryAnswers;
			self.conflictAnswers = response.data.conflictAnswers;
			self.resolvedId = response.data.resolvedId;
		});
	};

	self.nextConflict = function nextConflict() {
		self.currentConflict++;
	};

	self.prevConflict = function prevConflict() {
		self.currentConflict--;
	};

	self.applyCurrentConflict = function applyCurrentConflict() {
		var selectedConflict = self.conflictAnswers[self.currentConflict];
		applyStudentAnswers(selectedConflict.studentId);
	};

	self.applyPrimaryStudent = function applyPrimaryStudent() {
		applyStudentAnswers(self.primaryStudentId);
	};

	self.revertConflict = function revertConflict() {
		revertStudentAnswers();
	};

	function applyStudentAnswers(studentId) {
		$http.post(
			API_URL + "/" + self.selectedCase + "/resolve",
			{studentIdToApply: studentId}
		).then(function onSuccess() {
			self.resolvedId = studentId;

			for (var i = 0; i < self.conflicts.length; i++) {
				var conflict = self.conflicts[i];

				if (conflict.primaryStudentId === self.primaryStudentId) {
					conflict.resolvedStudentId = studentId;
				}
			}
		}, function onFailure(result) {
			showServerError(result);
		});
	}

	function revertStudentAnswers() {
		$http.post(
			API_URL + "/" + self.selectedCase + "/revert"
		).then(function onSuccess() {
			self.resolvedId = 0;

			for (var i = 0; i < self.conflicts.length; i++) {
				var conflict = self.conflicts[i];

				if (conflict.primaryStudentId === self.primaryStudentId) {
					conflict.resolvedStudentId = 0;
				}
			}
		}, function onFailure(result) {
			showServerError(result);
		});
	}

	function showServerError(result) {
		dxDialog.alert({
			title: "Error performing action",
			body: "Server encountered an error: " + result.data.message,
			acceptText: "Close",
			acceptCallback: function acceptCallback() {
				dxDialog.closeMostRecent();
			},
			escapeToClose: true,
			clickOutsideToClose: true,
		});
	}

	function triggerUpdate() {
		if ($interval.cancel(self.updateConflictsInterval)) {
			self.updateConflictsInterval = null;
		}

		self.updateConflicts();
		self.updateConflictsInterval = $interval(self.updateConflicts, 20000);
	}
	triggerUpdate();
});
